import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { requestSimilarOffers, TModelType } from '../../store/similar';
import { ISimilarOffersProps, SimilarOffers } from './index';
import { getUserEBC } from '../../utils/tracking/get_user_ebc';
import { getPageEBC } from '../../utils/tracking/get_page_ebc';

type TStoreProps = Pick<ISimilarOffersProps,
  'agent' | 'offer' | 'similarOffers'| 'withoutCompetitors' | 'modelVersion' | 'title' | 'user' | 'page'>;
type TDispatchProps = Pick<ISimilarOffersProps, 'requestSimilarOffers'>;
export interface IOwnProps {
  modelType: TModelType;
}

export function getTitle(modelType: TModelType, withoutCompetitors: boolean): string {
  if (withoutCompetitors) {
    return 'Другие предложения этого продавца';
  }

  switch (modelType) {
    case 'userBased':
      return 'Рекомендации по истории поиска';

    case 'itemBased':
      return 'Похожие предложения';
  }
}

export function mapStateToProps(state: IState, props: IOwnProps): TStoreProps {
  const { modelType } = props;
  const withoutCompetitors = state.similarOffers[modelType].withoutCompetitors || false;
  const modelVersion = state.similarOffers[modelType].modelVersion;
  const user = getUserEBC(state.offerData.user, state.abGroup);
  const page = getPageEBC(state.offerData.offer.id, state.offerData.breadcrumbs);

  return {
    title: getTitle(modelType, withoutCompetitors),
    agent: state.offerData.agent,
    offer: state.offerData.offer,
    similarOffers: state.similarOffers[modelType].list,
    withoutCompetitors,
    modelVersion,
    user,
    page,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>, props: IOwnProps): TDispatchProps {
  return {
    requestSimilarOffers: (offerId: number) => dispatch(requestSimilarOffers(offerId, props.modelType)),
  };
}

export const SimilarOffersContainer = connect<TStoreProps, TDispatchProps, IOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(SimilarOffers);
